module.exports = "<div class=\"sis-shell-nav__section-title\" *ngIf='isVisible'>{{title}}</div>\n<ng-content></ng-content>\n";